export const OPEN_AUDIO_DIALOG = "OPEN_AUDIO_DIALOG";
export const CLOSE_AUDIO_DIALOG = "CLOSE_AUDIO_DIALOG";
export const GET_AUDIO_LIST = "GET_AUDIO_LIST";
export const GET_AUDIO_LIST_SUCCESS = "GET_AUDIO_LIST_SUCCESS";
export const GET_AUDIO_LIST_ERROR = "GET_AUDIO_LIST_ERROR";

